import { useIntl } from 'react-intl';

import { formatResolution } from '../../../../../../formatters/resolution/resolution-formatter.js';
import type {
  FormatterWithPrecision,
  TimeFrameFormatter,
} from '../../../../../core/types/formatter.js';
import { XYCHART_MESSAGES } from '../../../../messages/messages.js';
import type { XYAccessorDataTypes } from '../../../../types/xy-chart.js';
import {
  isCategoricalTooltip,
  isNumericalToolTip,
  isTimeTooltip,
} from '../../../../utils/type-guards.js';

export function useRectSeriesTooltipHeaderContent(
  v0: XYAccessorDataTypes,
  v1?: XYAccessorDataTypes,
  formatter?: FormatterWithPrecision | TimeFrameFormatter,
) {
  const intl = useIntl();
  const separator = intl.formatMessage(XYCHART_MESSAGES.separatorDash);
  let duration: string | undefined = undefined;
  let text = '';

  const args = {
    formatter,
    v0,
    v1,
  };

  if (isCategoricalTooltip(args)) {
    text = args.v0;
  }

  if (isNumericalToolTip(args)) {
    text = `${args.formatter(args.v0)} ${separator} ${args.formatter(args.v1)}`;
  }

  if (isTimeTooltip(args)) {
    text = `${args.formatter(args.v0, args.v1)}`;
    duration = formatResolution(args.v0, args.v1);
  }

  return { duration, text };
}
